import { render, staticRenderFns } from "./GradeSeo.vue?vue&type=template&id=73bcd737&"
import script from "./GradeSeo.vue?vue&type=script&lang=js&"
export * from "./GradeSeo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports